import { PriceBadge } from "../../../../shared/PriceBadge";
import { priceListProperties } from "../../../../shared/PriceBadge/constants";
import type { PriceScenariosProps } from "../types";

export const Badge = ({ price }: PriceScenariosProps) => (
  <PriceBadge price={price} properties={priceListProperties} />
);
